import React, { useState } from "react";
import noImage from "../../../../src/images/No_image_available.svg";

const Image = (props) => {
  const [isBroken, setIsBroken] = useState(false);

  function handleImageError() {
    setIsBroken(true);
  }
  return (
    <>
      {isBroken || !props?.src ? (
        <img src={noImage} alt={"Not available"} border="0" />
      ) : (
        <img
          src={props?.src}
          onError={handleImageError}
          alt={!!props?.alt ? props?.alt : "no title"}
          border="0"
        />
      )}
    </>
  );
};
export default Image;
